import React from "react";
import BlockLayout from "./../Layout/BlockLayout";
import ComponentHeader from "../Header/ComponentHeader";
import KeyFigureNew from "../Elements/KeyFigureNew";
import { useInView } from "react-intersection-observer";
import {
  heading48,
  FiguresWrapper,
  HeadingMunicipality
} from "../../Util/StyleProps";
import { primaryColor, secondaryColor } from "../../Util/Colors";
import { calculatePercentage, periodToComma } from "../../Helpers/CommonHelper";
import SvgLayout from "./../Layout/SvgLayout";
import EmptySpace from "../Elements/EmptySpace";

const LandUseContainer = props => {
  const { data, sweden, blockColor, scroll } = props;
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0
  });

  let municipality1 = data[0];
  let municipality2 = data[1];

  let forestPercentage = 0;
  let agriculturePercentage = 0;
  let settelmentPercentage = 0;
  let otherPercentage = 0;
  let yearSweden = sweden.landuse ? sweden.landuse.year : "";

  if (sweden.landuse) {
    forestPercentage = calculatePercentage(
      sweden.landuse.forest,
      sweden.landuse.total
    );
    agriculturePercentage = calculatePercentage(
      sweden.landuse.agriculture,
      sweden.landuse.total
    );
    settelmentPercentage = calculatePercentage(
      sweden.landuse.settlements,
      sweden.landuse.total
    );
    otherPercentage = calculatePercentage(
      sweden.landuse.other,
      sweden.landuse.total
    );
  }
  //I hela Sverige används 2,9 procent av marken till bebyggelse. 69,1 procent är skog, 7,5 procent är jordbruksmark, och 20,6 procent är övrig mark (2015).

  let swedenString = `I hela Sverige används ${periodToComma(
    settelmentPercentage
  )} procent av marken till bebyggd och anlagd mark.  ${periodToComma(
    forestPercentage
  )} procent är skogsmark, ${periodToComma(
    agriculturePercentage
  )} procent är jordbruksmark, 
   och ${periodToComma(otherPercentage)} procent är öppen myrmark och övrig mark (${yearSweden}).`;

  // Accessibility
  const ariaLabel = municipality => {
    return municipality
      ? `I ${municipality.name} kommun används ${calculatePercentage(
          municipality.settlements,
          municipality.total
        )} procent av marken till bebyggd och anlagd mark.
      ${calculatePercentage(
        municipality.forest,
        municipality.total
      )} procent är skogsmark, ${calculatePercentage(
          municipality.agriculture,
          municipality.total
        )} procent är jordbruksmark, 
      och ${calculatePercentage(
        municipality.other,
        municipality.total
      )} procent är öppen myrmark och övrig mark (${yearSweden}).`
      : "";
  };

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px"}} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M46.4042 71.6668V61.3334H53.6476V71.6668H46.4042ZM26.4042 71.6668V58.9934H3.14172L18.3142 36.9293H10.7184L30.0001 9.55176L49.2817 36.9293H41.7692L56.9101 58.9934H33.6476V71.6668H26.4042ZM59.7367 58.9934L46.2501 39.2693H53.7434L41.4551 21.6926L50.0001 9.55176L69.2817 36.9293H61.7692L76.8584 58.9934H59.7367Z" fill="#0F0865"/>
        <path d="M26.4042 71.6668V58.9934H3.14172L18.3142 36.9293H10.7184L30.0001 9.55176L49.2817 36.9293H41.7692L56.9101 58.9934H33.6476V71.6668H26.4042Z" fill="#1F44FF"/>
        </svg>
        <ComponentHeader heading={"Så används marken"} text={swedenString} />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
              {municipality1 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                  marginBottom="24px"
                    aria-label={ariaLabel(municipality1)}
                  >
                    {municipality1.name}
                  </HeadingMunicipality>
                  <SvgLayout>
                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={0.75}
                      iconName={"house"}
                      alt="Ikon hus"
                      size={heading48}
                      value={calculatePercentage(
                        municipality1.settlements,
                        municipality1.total
                      )}
                      subText={"bebyggd och anlagd mark"}
                      unit={"%"}
                    />
                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={0.75}
                      iconName={"nature"}
                      alt="Ikon skog"
                      size={heading48}
                      value={calculatePercentage(
                        municipality1.forest,
                        municipality1.total
                      )}
                      subText={"skogsmark"}
                      unit={"%"}
                    />
                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={0.75}
                      iconName={"spa"}
                      alt="Icon sädesslag"
                      size={heading48}
                      value={calculatePercentage(
                        municipality1.agriculture,
                        municipality1.total
                      )}
                      subText={"jordbruksmark"}
                      unit={"%"}
                    />
                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={0.75}
                      iconName={"stripes"}
                      alt="Ikon ränder"
                      size={heading48}
                      value={calculatePercentage(
                        municipality1.other,
                        municipality1.total
                      )}
                      subText={"öppen myrmark och övrig mark"}
                      unit={"%"}
                      marginBottom={"0px"}
                    />
                  </SvgLayout>
                </SvgLayout>
              ) : (
                <div></div>
              )}
              {municipality2 ? (
                <SvgLayout width="47%">
                  <HeadingMunicipality
                  marginBottom="24px"
                    color={secondaryColor}
                    aria-label={ariaLabel(municipality2)}
                  >
                    {municipality2.name}
                  </HeadingMunicipality>
                  <SvgLayout>
                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={1.75}
                      iconName={"house"}
                      alt="Ikon hus"
                      color={secondaryColor}
                      size={heading48}
                      value={calculatePercentage(
                        municipality2.settlements,
                        municipality2.total
                      )}
                      subText={"bebyggd och anlagd mark"}
                      unit={"%"}
                    />

                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={1.75}
                      iconName={"nature"}
                      alt="Ikon skog"
                      color={secondaryColor}
                      size={heading48}
                      value={calculatePercentage(
                        municipality2.forest,
                        municipality2.total
                      )}
                      subText={"skogsmark"}
                      unit={"%"}
                    />
                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={1.75}
                      iconName={"spa"}
                      alt="Icon sädesslag"
                      color={secondaryColor}
                      size={heading48}
                      value={calculatePercentage(
                        municipality2.agriculture,
                        municipality2.total
                      )}
                      subText={"jordbruksmark"}
                      unit={"%"}
                    />
                    <KeyFigureNew
                      triggerAnimation={inView}
                      delay={1.75}
                      iconName={"stripes"}
                      alt="Ikon ränder"
                      color={secondaryColor}
                      size={heading48}
                      value={calculatePercentage(
                        municipality2.other,
                        municipality2.total
                      )}
                      subText={"öppen myrmark och övrig mark"}
                      unit={"%"}
                      marginBottom={"0px"}
                    />
                  </SvgLayout>
                </SvgLayout>
              ) : (
                <SvgLayout width="50%">
                  <EmptySpace scroll={scroll} />
                </SvgLayout>
              )}
            </FiguresWrapper>
          </div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

export default LandUseContainer;
